import React from 'react';
import { useTranslation } from 'react-i18next';

import Header from '../../../components/shared/Header/Header';
import { useOrganizationSelector } from '../../../hooks/useOrganizationSelector';
import Profile from '../Profile/Profile';

import styles from './CompanyPage.module.scss';

const CompanyPage = ({ isPublic }) => {
  const { t } = useTranslation('common');
  useOrganizationSelector();
  return (
    <div className={styles.container}>
      <Header isPublic={isPublic} title={t('headers.companyProfile')} />
      <Profile isPublic={isPublic} />
    </div>
  );
};

export default CompanyPage;
